import { ViewResultsModal } from "src/component/ViewResults";
import { UserProfileModal } from "src/component/UserProfileModal";
import { BroadcastModal } from "src/component/BroadcastMail/BroadcastModal";
import { ResetPasswordModal } from "src/component/ResetPassword";
import AddUserModal from "src/component/AddUserModal";
import EditUserModal from "src/component/EditUserModal";
import { LogoutModal } from "src/component";

export default () => {
  return (
    <>
      <LogoutModal />
      <ViewResultsModal />
      <UserProfileModal />
      <BroadcastModal />
      <ResetPasswordModal />
      <AddUserModal />
      <EditUserModal />
    </>
  );
};
